var _defs, _rect, _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#19afad;opacity:0;}.cls-2{fill:#4caf50;}.cls-3{fill:#fafafa;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "verified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,12A12,12,0,0,0,12,0h0A12,12,0,0,0,0,12H0A12,12,0,0,0,12,24h0A12,12,0,0,0,24,12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.08,8a1,1,0,0,1,0,1.42L11.58,16a1,1,0,0,1-1.41,0L6.92,12.71a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l2.55,2.55L16.67,8A1,1,0,0,1,18.08,8Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.0bd434dd.svg";
export { ForwardRef as ReactComponent };